import React from "react";
import "./Error.scss";
function Error() {
  return (
    <img
      className="h-full flex"
      // src={PUBLIC_URL+'assets/images/bg-auth.png'}
      src="assets/images/error.png"
      alt="background"
    />
  );
}

export default Error;
